import React from "react";
import "./QuoteCarousel.scss";
import { useState } from "react";
import { quote } from "../../types/carouselInterface";
import arrowLeft from "../../assets/icons/circleArrowLeft.svg";
import arrowRight from "../../assets/icons/circleArrowRight.svg";

interface QuoteCarouselProps {
  items: quote[];
}

const QuoteCarousel: React.FC<QuoteCarouselProps> = ({ items }) => {
  const [slide, setSlide] = useState<number>(0);
  const [touchPosition, setTouchPosition] = useState<number | null>(null);

  const nextSlide = () => {
    setSlide(slide === items.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? items.length - 1 : slide - 1);
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      nextSlide();
    }

    if (diff < -5) {
      prevSlide();
    }

    setTouchPosition(null);
  };

  return (
    <div
      className="testimonies"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <span
        onClick={prevSlide}
        className="testimonies__arrows testimonies__arrows--left"
      >
        <img src={arrowLeft} alt="Left Carousel Arrow" />
      </span>
      <div
        className={`testimonies__container testimonies__container--${slide}`}
      >
        {items.map((item, i) => (
          <section
            className={`testimonies__slide ${
              slide === i ? "testimonies__slide--active" : ""
            }`}
            key={i}
          >
            <h2 className="testimonies__name">{item.name}</h2>
            <h4 className="testimonies__subtitle">{item.subtitle}</h4>
            <p className="testimonies__testimony">{item.testimony}</p>
          </section>
        ))}
      </div>
      <span
        onClick={nextSlide}
        className="testimonies__arrows testimonies__arrows--right"
      >
        <img src={arrowRight} alt="Right Carousel Arrow" />
      </span>
      <span className="testimonies__indicators">
        {items.map((_, i) => {
          return (
            <button
              key={i}
              className={
                slide === i
                  ? "testimonies__indicator"
                  : "testimonies__indicator testimonies__indicator--inactive"
              }
              onClick={() => setSlide(i)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default QuoteCarousel;
